export default __webpack_public_path__ + "static/media/popover-triangle.035d4a1e.svg";